import React from 'react';
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import AccordionSummary from "@material-ui/core/AccordionSummary";

export default function Sidebar() {
  const auth = useSelector(state => state.auth);
  return (
    <div>
      <aside className="main-sidebar">
        <section className="sidebar">
          <div className="user-panel">
            <div className="pull-left image">
              <img
                src="https://adminlte.io/themes/v3/dist/img/user2-160x160.jpg"
                className="img-circle"
                alt="User Image"
              />
            </div>
            <div className="pull-left info">
              <p>{auth.user.fname} {auth.user.lname}</p>
              <a href="/#">
                <i className="fa fa-circle text-success" /> Online
              </a>
            </div>
          </div>
          {/* search form */}
          <form action="#" method="get" className="sidebar-form">
            <div className="input-group">
              <input
                type="text"
                name="q"
                className="form-control"
                placeholder="Search..."
              />
              <span className="input-group-btn">
                <button
                  type="submit"
                  name="search"
                  id="search-btn"
                  className="btn btn-flat"
                >
                  <i className="fa fa-search" />
                </button>
              </span>
            </div>
          </form>

          <ul className="sidebar-menu" data-widget="tree">
            <li className="header">MAIN NAVIGATION</li>

            <li>
              <Link to="/home">
                <i className="fa fa-dashboard" /> <span>Dashboard</span>
              </Link>
            </li>

            <li className="treeview main-menu">
              <Accordion>

                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                >
                  <Typography
                    style={{
                      fontWeight: 10,
                    }}
                  >
                    <Link to="#">
                      <i className="fa fa-bars"></i>
                      <span>General Options</span>
                      <span className="pull-right-container">
                      </span>
                    </Link>
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    <ul className="treeview sub-menu">
                      <li className=''>
                        <Link to="/generaloption">
                          <i className="fa fa-circle-o" /> <span>Manage General Option</span>
                          <span className="pull-right-container">
                          </span>
                        </Link>
                      </li>
                      <li>
                        <Link to="/cmslist">
                          <i className="fa fa-circle-o" /> <span>Manage CMS</span>
                          <span className="pull-right-container">
                          </span>
                        </Link>
                      </li>
                      <li>
                        <Link to="/cms">
                          <i className="fa fa-circle-o" /> <span>Add Page</span>
                          <span className="pull-right-container">
                          </span>
                        </Link>
                      </li>
                    </ul>
                  </Typography>
                </AccordionDetails>
              </Accordion>
            </li>

            <li className="treeview main-menu">
              <Accordion>

                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                >
                  <Typography
                    style={{
                      fontWeight: 10,
                    }}
                  >
                    <Link to="#">
                      <i className="fa fa-gift"></i>
                      <span>Products Manage</span>
                      <span className="pull-right-container">
                      </span>
                    </Link>
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    <ul className="treeview sub-menu">
                      <li className=''>
                        <Link to="/product">
                          <i className="fa fa-circle-o" /> <span>Manage Products</span>
                          <span className="pull-right-container">
                          </span>
                        </Link>
                      </li>
                      <li className=''>
                        <Link to="/newarrival">
                          <i className="fa fa-circle-o" /> <span>New Arrival</span>
                          <span className="pull-right-container">
                          </span>
                        </Link>
                      </li>
                      <li>
                        <Link to="/category">
                          <i className="fa fa-circle-o" /> <span>Manage Category</span>
                          <span className="pull-right-container">
                          </span>
                        </Link>
                      </li>
                    </ul>
                  </Typography>
                </AccordionDetails>

              </Accordion>
            </li>

            <li className="treeview main-menu order">
              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                >
                  <Typography
                    style={{
                      fontWeight: 10,
                    }}
                  >
                    <Link to="#">
                      <i className="fa fa-gift"></i>
                      <span>Orders Manage</span>
                      <span className="pull-right-container">
                      </span>
                    </Link>
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    <ul className="treeview sub-menu">
                      <li className=''>
                        <Link to="/orders">
                          <i className="fa fa-circle-o" /> <span>Orders</span>
                          <span className="pull-right-container">
                          </span>
                        </Link>
                      </li>
                      {/* <li>
                        <Link to="/#">
                          <i className="fa fa-circle-o" /> <span>Settings</span>
                          <span className="pull-right-container">
                          </span>
                        </Link>
                      </li>
                      <li>
                        <Link to="/#">
                          <i className="fa fa-circle-o" /> <span>Reports</span>
                          <span className="pull-right-container">
                          </span>
                        </Link>
                      </li>
                      <li>
                        <Link to="/status">
                          <i className="fa fa-circle-o" /> <span>Status</span>
                          <span className="pull-right-container">
                          </span>
                        </Link>
                      </li>
                      <li>
                        <Link to="/#">
                          <i className="fa fa-circle-o" /> <span>Customers</span>
                          <span className="pull-right-container">
                          </span>
                        </Link>
                      </li>
                      <li>
                        <Link to="/#">
                          <i className="fa fa-circle-o" /> <span>Export Orders</span>
                          <span className="pull-right-container">
                          </span>
                        </Link>
                      </li> */}
                    </ul>
                  </Typography>
                </AccordionDetails>
              </Accordion>
            </li>


            <li className="treeview main-menu vendor">
              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                >
                  <Typography
                    style={{
                      fontWeight: 10,
                    }}
                  >
                    <Link to="#">
                      <i className="fa fa-tags"></i>
                      <span>Brand Manage</span>
                      <span className="pull-right-container">
                      </span>
                    </Link>
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    <ul className="treeview sub-menu">
                      <li>
                        <Link to="/brand">
                          <i className="fa fa-circle-o" /> <span>Brands list</span>
                          <span className="pull-right-container">
                          </span>
                        </Link>
                      </li>
                      <li>
                        <Link to="/addbrand">
                          <i className="fa fa-circle-o" /> <span>Add new Brand</span>
                          <span className="pull-right-container">
                          </span>
                        </Link>
                      </li>
                    </ul>
                  </Typography>
                </AccordionDetails>
              </Accordion>
            </li>


            <li className='image'>
              <Link to="/image">
                <i className="fa fa-image" /><span>Media</span>
                <span className="pull-right-container">
                </span>
              </Link>
            </li>

            <li>
              <Link to="/sync">
                <i className="fa fa-refresh" /><span>Sync ERP Products</span>
                <span className="pull-right-container">
                </span>
              </Link>
            </li>





            <li className="treeview main-menu vendor">
              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                >
                  <Typography
                    style={{
                      fontWeight: 10,
                    }}
                  >
                    <Link to="#">
                      <i className="fa fa-users"></i>
                      <span>Customer Manage</span>
                      <span className="pull-right-container">
                      </span>
                    </Link>
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    <ul className="treeview sub-menu">
                      <li>
                        <Link to="/customer">
                          <i className="fa fa-circle-o" /> <span>Customer list</span>
                          <span className="pull-right-container">
                          </span>
                        </Link>
                      </li>
                    </ul>
                  </Typography>
                </AccordionDetails>

              </Accordion>
            </li>

            <li>
              <Link to="/couponlist">
                <i className="fa fa-tag" /> <span>Coupons Manage</span>
                <span className="pull-right-container">
                </span>
              </Link>
            </li>
            <li>
              <Link to="/settings">
                <i className="fa fa-gear" /> <span>Settings</span>
                <span className="pull-right-container">
                </span>
              </Link>
            </li>


            <li className="treeview main-menu market">
              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                >
                  <Typography
                    style={{
                      fontWeight: 10,
                    }}
                  >
                    <Link to="#">
                      <i className="fa fa-gears"></i>
                      <span>Marketing</span>
                      <span className="pull-right-container">
                      </span>
                    </Link>
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    <ul className="treeview sub-menu">
                      <li className=''>
                        <Link to="/orders">
                          <i className="fa fa-circle-o" /> <span>Overview</span>
                          <span className="pull-right-container">
                          </span>
                        </Link>
                      </li>
                      <li>
                        <Link to="/#">
                          <i className="fa fa-circle-o" /> <span>Offers Manage</span>
                          <span className="pull-right-container">
                          </span>
                        </Link>
                      </li>
                      <li>
                        <Link to="/addbanner">
                          <i className="fa fa-circle-o" /> <span>Banners</span>
                          <span className="pull-right-container">
                          </span>
                        </Link>
                      </li>
                      <li>
                        <Link to="/collaborators">
                          <i className="fa fa-circle-o" /> <span>Collaborators</span>
                          <span className="pull-right-container">
                          </span>
                        </Link>
                      </li>
                      <li>
                        <Link to="/brandbanners">
                          <i className="fa fa-circle-o" /> <span>Brand Banners</span>
                          <span className="pull-right-container">
                          </span>
                        </Link>
                      </li>
                      <li>
                        <Link to="/#">
                          <i className="fa fa-circle-o" /> <span>Product Collection</span>
                          <span className="pull-right-container">
                          </span>
                        </Link>
                      </li>
                      <li>
                        <Link to="/#">
                          <i className="fa fa-circle-o" /> <span>Campaigns</span>
                          <span className="pull-right-container">
                          </span>
                        </Link>
                      </li>
                      <li>
                        <Link to="/#">
                          <i className="fa fa-circle-o" /> <span>Analytics</span>
                          <span className="pull-right-container">
                          </span>
                        </Link>
                      </li>
                      <li>
                        <Link to="/#">
                          <i className="fa fa-circle-o" /> <span>Data</span>
                          <span className="pull-right-container">
                          </span>
                        </Link>
                      </li>
                      <li>
                        <Link to="/#">
                          <i className="fa fa-circle-o" /> <span>Coupons Manage</span>
                          <span className="pull-right-container">
                          </span>
                        </Link>
                      </li>
                      <li>
                        <Link to="/#">
                          <i className="fa fa-circle-o" /> <span>Plug INS</span>
                          <span className="pull-right-container">
                          </span>
                        </Link>
                      </li>
                      <li>
                        <Link to="/#">
                          <i className="fa fa-circle-o" /> <span>Hubspot</span>
                          <span className="pull-right-container">
                          </span>
                        </Link>
                      </li>
                      <li>
                        <Link to="/#">
                          <i className="fa fa-circle-o" /> <span>Appearance</span>
                          <span className="pull-right-container">
                          </span>
                        </Link>
                      </li>
                    </ul>
                  </Typography>
                </AccordionDetails>

              </Accordion>
            </li>

            <li className="treeview main-menu Offers">
              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                >
                  <Typography
                    style={{
                      fontWeight: 10,
                    }}
                  >
                    <Link to="#">
                      <i className="fa fa-money"></i>
                      <span>Offers Manage</span>
                      <span className="pull-right-container">
                      </span>
                    </Link>
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    <ul className="treeview sub-menu">
                      <li className=''>
                        <Link to="/coupon">
                          <i className="fa fa-circle-o" /> <span>Coupon</span>
                          <span className="pull-right-container">
                          </span>
                        </Link>
                      </li>
                      <li>
                        <Link to="/newdeals">
                          <i className="fa fa-circle-o" /> <span>New Deals</span>
                          <span className="pull-right-container">
                          </span>
                        </Link>
                      </li>
                    </ul>
                  </Typography>
                </AccordionDetails>

              </Accordion>
            </li>
            {/* <li className="header">LABELS</li>
            <li>
              <a href="#">
                <i className="fa fa-circle-o text-red" /> <span>Important</span>
              </a>
            </li>
            <li>
              <a href="#">
                <i className="fa fa-circle-o text-yellow" /> <span>Warning</span>
              </a>
            </li>
            <li>
              <a href="#">
                <i className="fa fa-circle-o text-aqua" /> <span>Information</span>
              </a>
            </li> */}
          </ul>
        </section>
        {/* /.sidebar */}
      </aside>

    </div>
  )
}